<template>
    <d-row class="social-logins">
      <d-col v-for="social in d_socials" :key="`social-login-${social.urlPath}`">
        <d-button @click="login(social.urlPath)" class="border" :class="`${social.urlPath}-login`" theme="light">
          <img :src="require(`@/assets/images/socials/${social.logoPath}`)" class="mr-1">

          {{ $t('button.social_login', { social: social.name }) }}
        </d-button>
      </d-col>
    </d-row>
</template>

<script>
import RedirectRequest from '@/library/RedirectRequest';

export default {
  name: 'auth-social-login',
  props: {
    loginChallenge: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      d_request: new RedirectRequest(),
      d_socials: [
        {
          urlPath: 'google',
          logoPath: 'google.svg',
          name: 'Google',
        },
      ],
    };
  },
  methods: {
    login (social) {
      const url = `login/${social}?login_challenge=${this.loginChallenge}`;

      this.d_request.get(url);
    },
  },
}
</script>
